import type { SearchFilters } from './noteSearch'

/**
 * Why Browse has nothing to list, so the empty state can say the right thing (docs/onboarding, S7): nothing at all, a search or filters
 * that match nothing, or one of the named views (Archive, Trash, Reminders, Quick Access) that is simply empty. A named view narrowed by
 * anything else (a tag, a second view) is "filters": "Reset filters" is then the useful action.
 */
export type SearchEmptyCause = 'search' | 'filters' | 'both' | 'empty' | 'archive' | 'trash' | 'reminders' | 'quickAccess'

export function searchEmptyCause(query: string, filters: SearchFilters): SearchEmptyCause {
  const named: SearchEmptyCause[] = [
    ...((filters.status ?? 'all') === 'archived' ? ['archive' as const] : []),
    ...(filters.status === 'trash' ? ['trash' as const] : []),
    ...(filters.hasAlarm ? ['reminders' as const] : []),
    ...(filters.quickAccess ? ['quickAccess' as const] : []),
  ]
  const others = Boolean(filters.property) || Boolean(filters.tag) || Boolean(filters.tags?.length) || filters.status === 'inbox' || filters.status === 'kept' || filters.status === 'snoozed' || filters.status === 'expired'
  const narrowed = named.length > 0 || others
  if (query.trim()) return narrowed ? 'both' : 'search'
  if (!narrowed) return 'empty'
  return named.length === 1 && !others ? named[0]! : 'filters'
}
